<template>
  <el-card shadow="never">
    <template slot="header" shadow="never">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Audit', path: { facility } }">Audit</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-button @click="() => $router.push({ name: 'Facility Audit void', path: { facility } })">
      Void Charges
    </el-button>
    <el-button @click="() => $router.push({ name: 'Facility Audit credits', path: { facility } })">
      Credits
    </el-button>
    <el-button @click="() => $router.push({ name: 'Facility Audit ccfw', path: { facility } })">
      CC Waiver
    </el-button>
    <el-button @click="() => $router.push({ name: 'Facility Audit transactions', path: { facility } })">
      Transactions
    </el-button>
  </el-card>
</template>

<script>
export default {
  name: 'Facility Audit',
  props: { facility: { type: String, required: true } },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FacilityAudit.vue